// Custom LOOXS attribute icons — thin-line, geometric, monochrome.
// Consistent stroke weight for a garment-label feel.
export function AttrIcon({ name, size = 28 }) {
  const props = { width: size, height: size, viewBox: "0 0 40 40", fill: "none", stroke: "currentColor", strokeWidth: "1", strokeLinecap: "square", "aria-hidden": true };
  switch (name) {
    case "fabric":     return <svg {...props}><path d="M6 12h28M6 22h28M6 32h28" /><path d="M12 6l8 28M20 6l8 28" opacity="0.4" /></svg>;
    case "tailoring":  return <svg {...props}><path d="M20 4v32" /><path d="M8 12l12-8 12 8" /><path d="M8 12v18l12 6 12-6V12" /></svg>;
    case "comfort":    return <svg {...props}><circle cx="20" cy="20" r="14" /><path d="M12 18c2 4 6 6 8 6s6-2 8-6" /></svg>;
    case "london":     return <svg {...props}><circle cx="20" cy="20" r="14" /><path d="M6 20h28M20 6c5 4 5 24 0 28M20 6c-5 4-5 24 0 28" opacity="0.5" /></svg>;
    case "shipping":   return <svg {...props}><rect x="4" y="14" width="20" height="14" /><path d="M24 18h8l4 6v4h-12z" /><circle cx="12" cy="30" r="2.5" /><circle cx="30" cy="30" r="2.5" /></svg>;
    case "returns":    return <svg {...props}><path d="M8 20a12 12 0 1 1 4 9" /><path d="M4 24l4 5 5-4" /></svg>;
    default:           return <svg {...props}><rect x="6" y="6" width="28" height="28" /></svg>;
  }
}

// Small swatch color chip — uses named colours from a subset; falls back to a
// neutral tone. Never used as the ONLY visual — always paired with a text label.
export const swatchColor = (name = "") => {
  const n = name.toLowerCase();
  const map = {
    "black": "#111",
    "ivory": "#f2ead9",
    "sand": "#d9c9a7",
    "navy": "#0b1c34",
    "stone": "#b9ada0",
    "deep olive": "#3c4028",
    "slate grey": "#565c60",
    "dusty rose": "#c5978d",
    "cocoa brown": "#4b352b",
    "obsidian": "#0a0a0a",
    "midnight": "#0d1224",
    "cognac": "#8b5a2b",
    "chocolate": "#3e2a1e",
    "ecru": "#efe6d5",
    "camel": "#c9a670",
    "charcoal": "#333",
    "white": "#f7f5f0",
    "crimson": "#7f1a24",
  };
  return map[n] || "#8a8a8a";
};
